import React, { useEffect, useRef } from "react";
import {
  GeneralContainer,
  ContentTitle,
  ContentLocation,
  ContentUsers,
  SelectField,
  ContentButtons,
  ButtonSave,
  customStyles,
} from "./SOSUsersSettings.styled";
import { Form } from "react-bootstrap";
import Select from "react-select";

const SOSUserSettings = ({
  countries,
  handleChangeSelectCountry,
  cities,
  handleChangeSelectCity,
  usersList,
  handleChangeSelectUser,
  selectedCountry,
  selectedCity,
  selectedUsers,
  saveUsers,
}) => {
  const rCountry = useRef();
  const rCity = useRef();
  const rUsers = useRef();
  useEffect(() => {
    rCity.current.clearValue();
    rUsers.current.clearValue();
  }, [selectedCountry]);

  useEffect(() => {
    rUsers.current.clearValue();
  }, [selectedCity]);

  return (
    <GeneralContainer>
      <ContentTitle>
        <label className="header-label">Users</label>
      </ContentTitle>
      <ContentLocation>
        <SelectField>
          <Form.Label>Country</Form.Label>
          <Select
            styles={customStyles}
            ref={rCountry}
            placeholder="Select a Country"
            options={countries}
            onChange={handleChangeSelectCountry}
          />
        </SelectField>
        <SelectField>
          <Form.Label>City</Form.Label>{" "}
          <Select
            styles={customStyles}
            placeholder="Select a City"
            options={cities}
            ref={rCity}
            onChange={handleChangeSelectCity}
          />
        </SelectField>
      </ContentLocation>
      <ContentUsers>
        <SelectField>
          <Form.Label>Select User</Form.Label>{" "}
          <Select
            styles={customStyles}
            placeholder="Select User"
            options={usersList}
            ref={rUsers}
            defaultValue={selectedUsers}
            value={selectedUsers}
            onChange={handleChangeSelectUser}
            isClearable={false}
            isMulti
          />
        </SelectField>
        <ContentButtons>
          <ButtonSave
            disabled={
              !selectedCountry || !selectedCity || selectedUsers.length === 0
            }
            onClick={() => {
              saveUsers();
            }}
          >
            Save Changes
          </ButtonSave>
        </ContentButtons>
      </ContentUsers>
    </GeneralContainer>
  );
};

export default SOSUserSettings;
